import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect } from 'C4';

import logo from 'assets/images/logo/logo_white.png';


export default class MiniChatView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="welcomeView">
        <BackImage />
        <div className="welcomeView__Wrapper">
        </div>
      </div>
    );
  }
}
